var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.isHRPlatform ? "title-header-standard" : "title-header"] },
    [
      _c(
        "div",
        {
          staticClass: "title-header-text",
          attrs: { id: "knowledge-categories" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _vm.showDropdownForKnowledgeBrowse
                  ? _c(
                      "div",
                      { staticClass: "dropdown w-auto d-inline-block" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "nav-link dropdown-btn pr-0",
                            attrs: {
                              "data-toggle": "dropdown",
                              "aria-expanded": "false",
                              href: "#"
                            }
                          },
                          [
                            _vm.currentServiceArea
                              ? _c(
                                  "span",
                                  { staticClass: "mr-1 nav-lnk-container" },
                                  [
                                    _c("span", { staticClass: "d-md-inline" }, [
                                      _vm._v(
                                        _vm._s(_vm.displayPlatformCategory) +
                                          " Articles:"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.currentTitleCategory))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "category-drop-down-arrow down"
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown-menu container-fluid category-container",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          _vm._l(_vm.serviceAreas, function(servicearea) {
                            return _c(
                              "div",
                              { key: servicearea.id },
                              [
                                _vm.validateArticlesLength(servicearea)
                                  ? _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "dropdown-item servicearea-dropdown-item",
                                        class: {
                                          "router-link-exact-active":
                                            servicearea.id ===
                                            _vm.currentServiceArea.id
                                        },
                                        attrs: {
                                          to: {
                                            name: servicearea.id
                                              ? "knowledge-articles-by-id"
                                              : "knowledge-articles",
                                            params: {
                                              platformCategory:
                                                _vm.platformCategory,
                                              id: servicearea.id
                                            }
                                          }
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.clickBKRoute(servicearea)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(servicearea.name) +
                                            " (" +
                                            _vm._s(
                                              servicearea.articles.length
                                            ) +
                                            ")"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "w-auto d-inline-block nav-lnk-container"
                      },
                      [
                        _c("span", { staticClass: "d-md-inline" }, [
                          _c("span", { staticClass: "nav-link-no-dropdown" }, [
                            _vm._v(
                              _vm._s(_vm.displayPlatformCategory) +
                                " Articles: " +
                                _vm._s(_vm.singleServiceLine.name) +
                                "(" +
                                _vm._s(_vm.singleServiceLine.articleCount) +
                                ")"
                            )
                          ])
                        ])
                      ]
                    ),
                _vm._v(" "),
                _c("employee-hub-bookmark", {
                  key: _vm.$route.params.id,
                  staticClass: "eh-bookmark",
                  attrs: { title: _vm.bookmarkTitle, "show-circle": "" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row h-auto" }, [
            _c("div", { staticClass: "col-xl-5 col-lg-6 col-12" }, [
              _vm.validateArticlesLength(_vm.currentServiceArea)
                ? _c("div", { staticClass: "search-container mt-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "input-group-prepend search-icon-container"
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-container" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inputSearchText,
                                expression: "inputSearchText"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              placeholder:
                                "Search all articles in the selected category"
                            },
                            domProps: { value: _vm.inputSearchText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.inputSearchText = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm.inputSearchText && _vm.inputSearchText.length > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "close close-btn mr-1",
                                on: { click: _vm.cleanSuggestedArticles }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: ["far", "times-circle"],
                                    size: "lg"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("img", { attrs: { src: require("@/assets/image/icon_search.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68e30cd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68e30cd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeCategories.vue
// module id = null
// module chunks = 